<template>
  <div class="connect_bg">
    <div class="connect_wrap help-wrap">
      <div class="connect_close_btn" @click="close"></div>
      <div class="title">无法开机</div>
      <div class="content-wrap">
        <div class="sub-content">
          <p>开机过程需要时间，请稍后查看设备状态；</p>
          <p>请确认被唤醒设备局域网内有一台设备端设备在线；</p>
          <p>请确认目标主机已开启WOL功能并且完成电源设置；</p>
        </div>
      </div>
      <div class="sure-btn" @click="close">确定</div>
    </div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {};
  },
  props: [],
  methods: {
    close: function () {
      let _that = this;
      _that.$emit("close");
    },
  },
  watch: {},
  mounted() {},
};
</script>

<style lang="less" scoped>
.connect_bg {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.1);
  z-index: 9;
  .connect_wrap {
    width: 400px;
    height: 280px;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-top: -140px;
    margin-left: -200px;
    background-color: #f5f5f5;
    background-image: linear-gradient(180deg, #f4f7ff 0%, #ffffff 19.79%);
    border-radius: 5px;
    box-shadow: 0px 0px 14px 2px #999999;

    .connect_close_btn {
      width: 20px;
      height: 20px;
      position: absolute;
      right: 20px;
      top: 14px;
      cursor: pointer;
      background-image: url(../../assets/common/close2.svg);
      background-size: 100% 100%;
    }
    .connecting_icon {
      width: 200px;
      height: 130px;
      background-image: url(../../assets/home/node/connecting_icon.svg);
      background-size: 100% auto;
      margin: 25px auto 15px auto;
    }
    .connecting_icon_failed {
      background-image: url(../../assets/home/node/connect_failed_icon.svg);
    }
    .connecting_error_title {
      color: #143977;
      font-weight: 600;
      font-size: 20px;
      line-height: 28px;
      text-align: center;
      margin-top: 28px;
      margin-bottom: 8px;
    }
    .sub-tips {
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      text-align: center;
      color: #9c9c9c;
    }
    .sub-tips2 {
      font-weight: 400;
      font-size: 14px;
      line-height: 24px;
      color: #666666;
      text-align: center;
      margin-top: 15px;
    }
    .connecting_title {
      font-size: 14px;
      color: #666666;
      font-weight: bolder;
      text-align: center;
      margin-top: 10px;
    }
    .connecting_name {
      color: #1f5de3;
      font-size: 16px;
      text-align: center;
      margin-bottom: 15px;
      font-weight: bolder;
    }
    .connecting_tips {
      color: #666666;
      font-size: 12px;
      text-align: left;
      margin: 0 auto;
      margin-top: 3px;
      width: 80%;
      .title {
        font-size: 14px;
        font-weight: bolder;
        margin-bottom: 4px;
      }
      .sub-title {
        font-size: 13px;
        font-weight: bolder;
        margin-bottom: 4px;
        margin-top: 6px;
      }
      span {
        color: #1f5de3;
        margin-left: 5px;
        cursor: pointer;
      }
    }
    .connecting_channel {
      width: 330px;
      height: 42px;
      background-color: #5187fd;
      background-image: linear-gradient(to right, #1f5de3, #5187fd);
      color: #c5f1ff;
      line-height: 42px;
      text-align: center;
      border-radius: 21px;
      margin: 0 auto;
      font-size: 13px;
      .connecting_channel_left {
        display: inline-block;
        vertical-align: top;
        width: 42px;
        height: 42px;
        line-height: 42px;
        background-image: url(../../assets/home/node/connect_channel_left.png);
        background-repeat: no-repeat;
        background-position: center center;
        background-size: 32px 20px;
        margin-right: 20px;
      }
      .connecting_channel_name {
        display: inline-block;
        vertical-align: top;
        height: 42px;
        line-height: 42px;
      }
      .connecting_channel_right {
        display: inline-block;
        vertical-align: top;
        height: 42px;
        width: 42px;
        line-height: 42px;
        background-image: url(../../assets/home/node/connect_channel_right.png);
        background-repeat: no-repeat;
        background-position: center center;
        background-size: 32px 20px;
        margin-left: 20px;
      }
    }
  }
  .connect_wrap.connect_vip_wrap {
    .connecting_channel {
      background-image: linear-gradient(to right, #f2d7b3, #d9ad84);
      .connecting_channel_left {
        background-image: url(../../assets/home/node/connect_channel_vip_left.png);
      }
      .connecting_channel_name {
        color: #795c24;
        font-weight: bolder;
        font-size: 14px;
      }
      .connecting_channel_right {
        background-image: url(../../assets/home/node/connect_channel_vip_right.png);
      }
    }
    .connecting_title {
      color: #795c24;
    }
  }
}

.sure-btn {
  margin: 0 auto;
  margin-top: 20px;
  width: 125px;
  height: 42px;
  background-color: #243a5e;
  background-image: linear-gradient(157.05deg, #243a5e 19.08%, #1c2f4d 90.93%);
  border-radius: 126px;
  text-align: center;
  font-weight: 400;
  font-size: 14px;
  line-height: 42px;
  color: #ffffff;
}

.sure-btn:hover {
  cursor: pointer;
  opacity: 0.9;
}

.connect_wrap.help-wrap {
  z-index: 10;
  .title {
    font-weight: 600;
    font-size: 20px;
    line-height: 28px;
    text-align: center;
    color: #143977;
    margin-top: 20px;
    margin-bottom: 45px;
  }
  .content-wrap {
    width: 330px;
    margin: 0 auto;
    margin-top: 35px;
    .sub-title {
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 22px;

      color: #000000;
      margin-top: 20px;
    }

    .sub-title2 {
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 22px;

      color: #000000;
      margin-top: 20px;
    }
    .sub-sub-title {
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 20px;

      color: #4277ff;
      margin-top: 20px;
      margin-bottom: 2px;
    }
    .sub-content {
      margin-bottom: 45px;
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;

      color: #000000;
      span {
        color: #acacac;
      }
    }
  }
}
</style>